import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import React, { useEffect } from 'react'
import Typography from '../Typography/Typography'
import { useRadio } from './RadioContext'

interface RadioLabelProps {
  helperText?: string
}

function Label({
  children,
  helperText,
}: PropsWithChildren<RadioLabelProps>): JSX.Element {
  const [{ direction, disabled, name }, , setLabelledBy] = useRadio()

  const id = `${name}-label`

  useEffect(() => setLabelledBy(id), [id])

  return (
    <span
      className={clsx(
        direction === 'col' ? 'pb-1' : null,
        direction === 'row' ? 'mr-4' : null,
        disabled ? 'opacity-50' : null,
      )}
      id={id}
    >
      <Typography variant="subtitle2">{children}</Typography>
      {helperText ? (
        <span className="block">
          <Typography variant="subtitle3">{helperText}</Typography>
        </span>
      ) : null}
    </span>
  )
}

export default Label
